import { useMemo } from 'react';
import type { Epic } from '../../../../../api/tasks-client/task-client.type';
import { useFlowByPhaseTabStore, useStrategyStore } from '../../../../../store/strategy-store/strategy-store';
import { searchEpics } from '../../initiative-performance.helpers';

/**
 * Hook that returns filtered and sorted epics based on user-selected criteria
 * @returns Filtered and sorted array of epics
 */
const useFilteredEpics = (): Epic[] | [] => {
  const initiative = useStrategyStore((state) => state.initiativePerformance);

  const searchTerm = useFlowByPhaseTabStore((state) => state.filterControls.searchTerm);
  const sortBy = useFlowByPhaseTabStore((state) => state.filterControls.sortBy);
  const sortDirection = useFlowByPhaseTabStore((state) => state.filterControls.sortDirection);
  const hideEmpty = useFlowByPhaseTabStore((state) => state.filterControls.hideEmpty);

  // Process the epics with filtering and sorting
  const processedEpics = useMemo(() => {
    if (!initiative?.epics?.length) {
      return [];
    }

    const result = searchEpics(initiative.epics, { searchTerm, sortBy, sortDirection, hideEmpty });

    return result;
  }, [initiative?.epics, searchTerm, sortBy, sortDirection, hideEmpty]);

  return processedEpics;
};

export { useFilteredEpics };
